module.exports = __webpack_public_path__ + "media/henriktune.90a33ee8.wav";